export enum StroopConfigurationOptions {
    None = 0,
    Standart = 1,
    // OtherColourSet = 2,
}
